<template>

  <div class="contacts">
    <v-card
      class="mx-auto fixed-header"
    >
      <v-app-bar
        dark
        class="fixed-header"
        style="background-color: #ffffff;color:black"
      >
        <!--      <v-app-bar-nav-icon></v-app-bar-nav-icon>-->
        <div class="circle-img">
          <img :src="get_user_image()" />
        </div>
        <v-toolbar-title>
        <span class="router-name">
          {{$route.meta.name}}
        </span>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <div class="col-2 text-center color-white">
          <span v-on:click="goAddGroup()">
             <v-icon color="black" >
                mdi-account-multiple-plus
              </v-icon>
          </span>
        </div>
        <div class="col-2 text-center color-white">
          <div class="">
            <v-dialog
              v-model="dialog"
              width="500"
            >
              <template v-slot:activator="{ on, attrs }">
                <button
                  class="btn"
                  v-bind="attrs"
                  v-on="on"
                >
                 <span>
                   <v-icon color="black" >
                      mdi-plus
                    </v-icon>
                </span>
                </button>
              </template>

              <v-card class="add-contact blue-border">

                <div class="add-header">{{ $t('addContact') }}<img src="../../../public/img/zoodkomak.png" />
                </div>

                <v-card-text>
                  <v-text-field
                    :label="$t('contactPhoneNo')"
                    v-model="contact_phone"
                    outlined
                  >
                  </v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <div class="modal-footer">
                  <div class="row">
                    <div class="col-6">
                      <button v-on:click="AddContact()">{{ $t('ok') }}</button>
                    </div>
                    <div class="col-6">
                      <button @click="dialog = false">{{ $t('cancel') }}</button>
                    </div>
                  </div>

                </div>
              </v-card>
            </v-dialog>

          </div>

        </div>
        <v-btn v-on:click="$router.go(-1)" :v-if='$route.meta.name != {{ $t('home') }}' icon>
          <v-icon color="black" >mdi-chevron-left</v-icon>
        </v-btn>
      </v-app-bar>

    </v-card>
    <br>
    <br>
    <br>


    <div class="contact-preview"  v-for="item in items"  v-on:click="goToDetail(item)">
      <div class="row" @contextmenu="openMenu($event, item)">
        <div class="col-2 no-padding-l">
          <img :src="item.ImageUrl" />
        </div>
        <div class="col-6">
          <span class="contact-username">
            {{ item.UserName }}
          </span>
        </div>
        <div class="col-4">
          <span class="contact-code">
            {{ item.UserCode }}
          </span>
        </div>
      </div>
    </div>

    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list>

        <v-list-item>
          <v-list-item-title>
                      <span v-on:click="removeMessage(show_detail)">
                        {{ $t('deleteMessage') }}
                      </span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog
      v-model="dialog2"
      width="500"
    >

      <v-card class="add-contact blue-border">

        <div class="add-header">{{ $t('add_contact') }}<img src="../../../public/img/zoodkomak.png" />
        </div>

        <v-card-text>
          hi
        </v-card-text>

        <v-divider></v-divider>

        <div class="modal-footer">
          <div class="row">
            <div class="col-6">
              <button v-on:click="AddContact()">{{ $t('ok') }}</button>
            </div>
            <div class="col-6">
              <button @click="dialog = false">{{ $t('cancel') }}</button>
            </div>
          </div>

        </div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

  import { bus } from '../../main'

  export default {
    data () {
      return {
        phone :'',
        password :'',
        lastItemId: 0,
        lastLogId: 0,
        dialog: false,
        dialog2: false,
        contact_phone: '',
        items: '',
        showMenu: false,
        show_detail: '',
        x: 0,
        y: 0,
      }
    },
    methods: {
      goToDetail (item) {
        console.log('iteem', item)
        const last_chat_detail = {
          RecType: 0,
          UserOrGroupId : item.ContactId,
          GetReceiver : item.GetReceiver
        }
        localStorage.setItem('lastChat', JSON.stringify(last_chat_detail))
        this.$router.push({ name: this.$t('conversation'), params: {} })
      },
      openMenu (e, item) {
        console.log('open', item)
        this.show_detail = item
        e.preventDefault()
        this.showMenu = false
        this.x = e.clientX
        this.y = e.clientY
        this.$nextTick(() => {
          this.showMenu = true
        })
      },
      removeMessage (item) {
        console.log('remove : ' + JSON.stringify(item))
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          RecId: item.UserContactId,
          ContactName: item.UserName
        }
        var self = this
        this.axios.post('/DeleteUserContact', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response delete ', response.data)
            }
          }).catch(e => {

        })
      },
      backToChats () {
        // this.$router.push({ path: '/dashboard', params: {} })
        this.$router.go(-1)
      },
      getAllContacts () {
        this.phone = localStorage.getItem('phone')
        this.password = localStorage.getItem('password')
        const send_data = {
          Phone:this.phone,
          Password: this.password,
          LastItemId: this.lastItemId,
          LastLogId: this.lastLogId
        }
        var self = this
        this.axios.post('/ShowAllGroupContacts', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response edit', response.data.contacts)
              this.items = response.data.contacts
            }
          }).catch(e => {

        })
      },
      AddContact () {
        var self=this;
        this.phone = localStorage.getItem('phone')
        this.password = localStorage.getItem('password')
        // console.log("hi" + this.contact_phone.substring(1))
        var editedphone = this.contact_phone.substring(1)
        editedphone = '' + editedphone
        // this.contact_phone = this.contact_phone.replace('0', '+98');
        const send_data = {
          UserPhone:this.phone.replace('+98',""),
          ContactPhone: editedphone,
          Password: this.password
        }
        var self = this
        this.axios.post('/AddUserContact', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [1500, response.data.msg])

            if (response.data.error == 0) {
              console.log('response edit', response.data)
              self.dialog= false
              self.getAllContacts()
            }
          }).catch(e => {

        })
      },
      DeleteContact () {
        this.dialog2 = true
      },
      goAddGroup () {
        this.$router.push({ path: '/add-group', params: {} })
      },
      mousePress () {
        console.log('hi')
      },
      mouseRelease () {
        console.log('hello')
      }
    },
    mounted () {
      this.getAllContacts()
    }
  }
</script>
